import { render, staticRenderFns } from "./SalasTempoReal.vue?vue&type=template&id=6c0c1b28&scoped=true"
import script from "./SalasTempoReal.vue?vue&type=script&lang=js"
export * from "./SalasTempoReal.vue?vue&type=script&lang=js"
import style0 from "./SalasTempoReal.css?vue&type=style&index=0&id=6c0c1b28&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c1b28",
  null
  
)

export default component.exports